/**
 * Authenticated fetch wrapper.
 *
 * Drop-in replacement for fetch() that:
 * 1. Sends httpOnly cookies via credentials: 'include'
 * 2. Injects Bearer token from localStorage as fallback (transition period)
 */
export async function authFetch(url: string, options?: RequestInit): Promise<Response> {
  const token = localStorage.getItem('authToken');
  const headers = new Headers(options?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers, credentials: 'include' });
}
